import {
  ADD_BANK_DETAILS,
  ADD_BASIC_DETAILS,
  ADD_CREDIT_DETAILS,
  ADD_DEALER_QR_CODE,
  ADD_KYC_DETAILS,
  GET_CREDIT_DETAILS,
  GET_DEALER_LIST,
  GET_DEALER_QR_CODE,
  GET_WALLET_AMOUNT,
  GET_WALLET_COIN,
  RESET_DEALER,
  UPDATE_BASIC_DETAILS,
  GET_NOTIFICATION_PREFERENCE,
  GET_USER_NOTIFICATION_PREFERENCE,
  GET_USER_ROLE,
  ADD_USER_ROLE,
  GET_DEALER_ADDRESS,
  DEALER_USER_ROLE,
  DEALER_USER_PARENT_ROLE,
} from "../types";

const initialState = {
  dealerData: {
    basicDetails: {},
    kycDetails: {},
    financeData: [],
    walletAmount: 0,
    coinAmount: 0,
    bankDetails: {},
    qrCode: [],
    userNotificationPref: [],
    dealerAddress: [],
    dealerUserRoles: [],
    dealerParentRoles: [],
  },

  dealerList: [],
  total: 0,
};

export default function dealerReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case ADD_BASIC_DETAILS:
      return {
        ...state,
        dealerData: { ...state?.dealerData, basicDetails: payload },
      };

    case ADD_BANK_DETAILS:
      return {
        ...state,
        dealerData: { ...state?.dealerData, bankDetails: payload },
      };

    case ADD_CREDIT_DETAILS:
      return {
        ...state,
        dealerData: { ...state?.dealerData, ...payload },
      };

    case GET_CREDIT_DETAILS:
      return {
        ...state,
        dealerData: { ...state?.dealerData, financeData: payload },
      };

    case GET_WALLET_AMOUNT:
      return {
        ...state,
        dealerData: { ...state?.dealerData, walletAmount: payload },
      };

    case GET_WALLET_COIN:
      return {
        ...state,
        dealerData: { ...state?.dealerData, coinAmount: payload },
      };

    case ADD_KYC_DETAILS:
      return {
        ...state,
        dealerData: { ...state?.dealerData, kycDetails: payload },
      };
    case GET_DEALER_LIST:
      return {
        ...state,
        dealerList: payload?.data,
        total: payload?.total,
      };

    case UPDATE_BASIC_DETAILS:
      return {
        ...state,
        dealerData: {
          ...state?.dealerData,
          basicDetails: { ...state?.dealerData?.basicDetails, ...payload },
        },
      };

    case GET_DEALER_QR_CODE:
      return {
        ...state,
        dealerData: { ...state?.dealerData, qrCode: payload },
      };
    case ADD_DEALER_QR_CODE:
      return {
        ...state,
        dealerData: {
          ...state?.dealerData,
          qrCode: [...state?.dealerData?.qrCode, payload],
        },
      };
    case GET_USER_NOTIFICATION_PREFERENCE:
      return {
        ...state,
        userNotificationPref: payload,
      };
    case GET_USER_ROLE:
      return {
        ...state,
        userRoles: payload,
      };
    case ADD_USER_ROLE:
      return {
        ...state,
        dealerData: { ...state?.dealerData, userRoles: payload },
      };
    case GET_DEALER_ADDRESS:
      return {
        ...state,
        dealerAddress: payload,
      };
    case DEALER_USER_ROLE:
      return {
        ...state,
        dealerUserRoles: payload,
      };
    case DEALER_USER_PARENT_ROLE:
      return {
        ...state,
        dealerParentRoles: payload,
      };

    case RESET_DEALER:
      return {
        ...state,
        dealerData: {
          basicDetails: {},
          kycDetails: {},
          financeData: [],
          walletAmount: {},
          coinAmount: {},
          bankDetails: {},
          qrCode: [],
        },
      };
    default:
      return state;
  }
}
